"use strict";
// Generated by robots, do not change this manually!
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2c = void 0;
var b2c_1 = require("./b2c");
Object.defineProperty(exports, "b2c", { enumerable: true, get: function () { return b2c_1.b2c; } });
//# sourceMappingURL=index.js.map